<template>
  <div class="h-full flex flex-col">
    <div class="flex mb-10px flex-wrap">
      <el-input
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请输入设备名称"
        v-model="equipSearchData.keyword"
        clearable
      ></el-input>
      <el-select
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择区域"
        v-model="equipSearchData.areaId"
        filterable
        clearable
      >
        <el-option
          v-for="item in areaList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <department-select
        ref="departmentSelect"
        class="mr-10px !w-50 mb-10px"
        v-model="equipSearchData.ownedUnitId"
      ></department-select>
      <el-button class="mb-10px" size="small" type="primary" @click="handleSearch">搜索</el-button>
      <el-button class="mb-10px" size="small" @click="resetText()">重置</el-button>
      <el-button
        class="mb-10px"
        size="small"
        type="primary"
        @click="handleEvent(null, 'create')"
        :disabled="!$hasAccess('create')"
        >新增</el-button
      >
      <el-button
        class="mb-10px"
        size="small"
        type="danger"
        @click="handleEvent(null, 'batchDelete')"
        :disabled="!$hasAccess('delete')"
        >批量删除</el-button
      >
      <el-button
        class="mb-10px"
        size="small"
        @click="handleEvent(null, 'batchImport')"
        :disabled="!$hasAccess('batchImport')"
        >导入</el-button
      >
      <el-button
        class="mb-10px"
        size="small"
        @click="handleEvent(null, 'batchExportQrCodePDF')"
        :disabled="!$hasAccess('batchExportQrCode')"
        >导出二维码</el-button
      >
      <!-- TODOS: 后续按照需求放开 -->
      <!-- <el-dropdown :disabled="!$hasAccess('batchExportQrCode')" class="ml-10px">
        <el-button>导出二维码<i class="el-icon-arrow-down pl-5px"></i></el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            @click.native="handleEvent(null, 'batchExportQrCodePDF')"
            :disabled="!$hasAccess('batchExportQrCode')"
            >导出PDF</el-dropdown-item
          >
          <el-dropdown-item
            @click.native="handleEvent(null, 'batchExportQrCodePNG')"
            :disabled="!$hasAccess('batchExportQrCode')"
            >导出PNG</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown> -->
    </div>
    <div class="flex-auto h-0px">
      <el-table
        :data="equipDataList"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="equipTableLoading"
        @selection-change="handleSelectionEquip"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column
          label="设备设施名称"
          prop="name"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="设备类别" prop="type" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.type !== null">{{ equipTypeMap(scope.row.type) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="编号" prop="no" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="危险介质"
          prop="hazardousMedia"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="所在区域"
          width="120"
          prop="areaText"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="所属单位"
          width="120"
          prop="ownedUnitText"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="是否属于特种设备"
          prop="isSpecialText"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="KKS编码" prop="kksNo" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="是否评价过"
          width="120"
          prop="isAppraiseText"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="风险上报人"
          width="120"
          prop="reportName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="时间" prop="creationTime" width="260" show-overflow-tooltip>
          <template slot-scope="scope">
            {{
              scope.row.creationTime && dayjs(scope.row.creationTime).format('YYYY-MM-DD HH:mm:ss')
            }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="300">
          <template slot-scope="scope">
            <table-operate-button :key="scope.row.id" :buttons="buttonsEquip(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="equipTableSizeChange"
        @current-change="equipTableCurrentChange"
        :current-page.sync="equipPageConfig.SkipCount"
        :page-size.sync="equipPageConfig.MaxResultCount"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="equipTotalCount"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>
    <!-- 表单 -->
    <equip-form
      :FormData="FormData"
      @refreshList="
        formDialog = false
        getEquipList()
      "
      @cancel="formDialog = false"
      v-if="formDialog"
      :formProps="formProps"
    ></equip-form>

    <qr-code v-if="codeDialog" :equipObj="equipObj" @cancel="codeDialog = false"></qr-code>

    <wiz-upload-file
      v-dialogDrag
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
    ></wiz-upload-file>
  </div>
</template>

<script>
import { AreaApi } from '@wiz-api/area-management'
import { EquipmentFacilityListApi } from '@wiz-api/double-prevention-management'
import { wizUploadFile } from '@wiz-core/compts'
import DepartmentSelect from '@/components/safety/DepartmentSelect/DepartmentSelect'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import DownResultFile from '@/assets/js/safety/DownResultFile'
import utils from '@/components/safety/enumField/utils'
import EquipForm from './EquipForm'
import QrCode from './QrCode'

const areaApi = new AreaApi()
const equipmentFacilityListApi = new EquipmentFacilityListApi()

export default {
  name: 'equip-table',
  mixins: [DownResultFile],
  components: {
    TableOperateButton,
    EquipForm,
    DepartmentSelect,
    QrCode,
    wizUploadFile,
  },
  data() {
    return {
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 0, // 目前状态页面0为下载模板 1为上传模板 2为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      equipObj: null,
      FormData: {
        name: '',
        no: '',
        type: 0,
        hazardousMedia: '',
        areaId: '',
        ownedUnitId: '',
        isSpecial: true,
        kksNo: '',
        riskAnalysisUnitId: '',
        imageIds: '',
        remark: '',
      },
      formDialog: false,
      formProps: {
        // create 新增 update 编辑 read 详情
        pageType: 'create',
      },
      codeDialog: false,
      departmentList: [],
      areaList: [],
      // 设备设施清单
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      equipSearchData: {
        ownedUnitId: undefined,
        areaId: undefined,
        keyword: '',
      },
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      selectionEquipData: [],
      equipTypeList: [],
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    equipTypeMap() {
      return (val) => {
        return (
          this.equipTypeList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    buttonsEquip() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.handleEvent(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
          {
            text: '编辑',
            click: () => {
              return this.handleEvent(val, 'update')
            },
            isShow: this.$hasAccess('update'),
          },
          {
            text: '删除',
            click: () => {
              return this.handleEvent(val, 'delete')
            },
            isShow: this.$hasAccess('delete') && val.isAppraise !== true,
          },
          {
            text: '二维码',
            click: () => {
              return this.handleEvent(val, 'readQrCode')
            },
            isShow: this.$hasAccess('readQrCode'),
          },
        ]
      }
    },
  },
  created() {
    this.getEquipList()
    utils.getDataCategory(
      ['DoublePreventionManagement.DataCategory.EquipmentType'],
      ['equipTypeList'],
      this
    )
    // 获取区域列表
    this.getAreaList()
  },
  methods: {
    // 选中
    handleSelectionEquip(values) {
      this.selectionEquipData = values
    },
    // 重置
    resetText() {
      this.equipSearchData = this.$options.data().equipSearchData
      this.$refs.departmentSelect.userName = ''
      this.handleSearch()
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    // 列表操作-事件 设备设施清单
    async handleEvent(row = null, operation) {
      let err = null
      let res = null
      let selectionEquipData = []
      switch (operation) {
        case 'create':
          this.FormData = this.$options.data().FormData
          this.initDialog(operation)
          break
        case 'delete':
          this.$confirm('是否删除该记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              ;[err, res] = await equipmentFacilityListApi.callDelete(row.id)
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success',
                })
                this.getEquipList()
              }
            })
            .catch(() => {})
          break
        case 'read':
          this.FormData = this.$options.data().FormData
          ;[err, res] = await equipmentFacilityListApi.get(row.id)
          if (!err) {
            const { creationTime, ...otherData } = res
            this.FormData = {
              ...this.FormData,
              ...otherData,
            }
            this.initDialog(operation)
          }
          break
        case 'batchImport':
          this.uploadFileProps.active = 0
          this.uploadFileProps.visible = true
          break
        case 'batchExportQrCodePDF':
          if (!this.selectionEquipData || this.selectionEquipData.length === 0) {
            this.$message({
              showClose: true,
              message: '请勾选要导出的记录',
              type: 'warning',
            })
            return
          }
          selectionEquipData = this.selectionEquipData.map((item) => {
            return item.id
          })
          ;[err, res] = await equipmentFacilityListApi.getQRCodePDF({
            body: selectionEquipData,
          })
          if (!err) {
            this.$message({
              showClose: true,
              message: '导出成功',
              type: 'success',
            })
            const fileStream = this.base64ToBolb(res)
            this.exportFile(fileStream, '设备设施二维码')
          }
          break
        case 'batchExportQrCodePNG':
          ;[err, res] = await equipmentFacilityListApi.gengQrCode({
            type: 0,
            id: row.id,
          })
          if (!err) {
            this.$message({
              showClose: true,
              message: '导出成功',
              type: 'success',
            })
          }
          break
        case 'update':
          this.FormData = this.$options.data().FormData
          ;[err, res] = await equipmentFacilityListApi.get(row.id)
          if (!err) {
            const { creationTime, ...otherData } = res
            this.FormData = {
              ...this.FormData,
              ...otherData,
            }
            this.initDialog(operation)
          }
          break
        case 'readQrCode':
          this.equipObj = row
          this.codeDialog = true
          break
        case 'batchDelete':
          if (!this.selectionEquipData.length || this.selectionEquipData.length === 0) {
            this.$message({
              showClose: true,
              message: '请勾选要删除的记录',
              type: 'warning',
            })
            return
          }

          const canDelete = this.selectionEquipData.some((item) => {
            return item.isAppraise === true
          })

          if (canDelete) {
            this.$message({
              showClose: true,
              message: '勾选的设备存在评价为是的记录，无法删除',
              type: 'warning',
            })
            return
          }
          this.$confirm('删除后将无法恢复, 确认删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(async () => {
            selectionEquipData = this.selectionEquipData.map((item) => {
              return item.id
            })
            ;[err, res] = await equipmentFacilityListApi.deleteMany({
              ids: selectionEquipData,
            })
            if (!err) {
              this.$message({
                showClose: true,
                message: '删除成功',
                type: 'success',
              })
              this.getEquipList()
            }
          })
          break
        default:
          break
      }
    },
    // 下载模板
    async exportTemplate() {
      const [err, res] = await equipmentFacilityListApi.importFromExcelTemplateFile()
      if (!err) {
        this.downLoadExcel('设备设施清单', res)
        this.$message({
          showClose: true,
          message: '模板下载成功',
          type: 'success',
        })
      }
    },
    // 上传文件
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('input', value)
      })
      const [err, res] = await equipmentFacilityListApi.importFromExcelFile({
        input: formData.get('input'),
      })
      if (!err) {
        if (res.code === 1) {
          this.uploadFileProps.successCount = res.data?.numberSuccesses
          this.uploadFileProps.failureCount = res.data?.numberFailures
          // 如需兼容老样式，则resultFile字段为空或者不设置皆可
          this.uploadFileProps.resultFile = res.data?.fileId
          this.uploadFileProps.active = 2
          this.handleSearch()
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          })
        }
      }
      this.uploadFileProps.btnLoading = false
    },
    base64ToBolb(res) {
      const raw = window.atob(res)
      const rawLength = raw.length
      const uInt8Array = new Uint8Array(rawLength)
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      return new Blob([uInt8Array])
    },
    // 下载文件
    exportFile(data, name) {
      const blob = new Blob([data], {
        type: 'application/pdf',
      })
      const blobUrl = window.URL.createObjectURL(blob)
      const templink = document.createElement('a')
      templink.style.display = 'none'
      templink.href = blobUrl
      templink.setAttribute('download', `${name}`)
      document.body.appendChild(templink)
      templink.click()
      document.body.removeChild(templink)
      window.URL.revokeObjectURL(blobUrl)
    },
    downLoadExcel(fileName = '下载文件', data) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${fileName}`
      link.click()
      window.URL.revokeObjectURL(link.href)
    },
    // 弹窗初始化操作
    initDialog(operation) {
      this.formDialog = true
      this.formProps.pageType = operation
    },
    // 搜索 equip 设备设施 job 作业活动
    handleSearch() {
      this.equipPageConfig.SkipCount = 1
      this.getEquipList()
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    // 设备设施列表
    async getEquipList() {
      this.selectionEquipData = []
      const data = {
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
        ...this.equipSearchData,
      }
      this.equipTableLoading = true
      const [err, res] = await equipmentFacilityListApi.pagedListQuery(data)
      if (!err) {
        this.equipDataList = res.items
        this.equipTotalCount = res.totalCount
      }
      this.equipTableLoading = false
    },
  },
}
</script>

<style lang="scss" scoped></style>
